import { MakeCall } from './createMakeCall';

const deleteListingVideo =
  (makeCall: MakeCall) => (listingId: number, videoId: number) =>
    makeCall<undefined>(
      'DELETE',
      `/api/v2/listing/${listingId}/video/${videoId}`,
    );

export { deleteListingVideo };
